import { Component, Vue } from 'vue-property-decorator'
import CAJG1080Service from './CAJG1080Service'
import CAJG1080ViewModel from './CAJG1080ViewModel'
import { XSSFilterOptions } from '@/common/XSSFilterOptions'
import '@/assets/css/colorbox.css'
import ShowMore from '@/assets/js/components/show-more.js'
import CommonUtil from '@/common/utils/CommonUtil'
import CommonConstants from '@/common/CommonConstants'
import OtherUrlConstants from '@/common/OtherUrlConstants'
import TransportService from '@/common/TransportService'
import { DigitalBookButton } from '@/common/utils/modules-util'
import { fixedContent } from '@/assets/js/main.js'
@Component({
  name: 'CAJG1080',
  components: {}
  })
export default class CAJG1080Controller extends Vue {
  private XSSFilterOptions = XSSFilterOptions
  private OtherUrlConstants = OtherUrlConstants
  private cajg1080ViewModel: CAJG1080ViewModel = {
    periodicalsHtmlInfo: {
      content: ''
    }
  }

  private cajg1080Service: CAJG1080Service = new CAJG1080Service()
  /**
   * 画面要素描画後処理
   */
  async mounted() {
    fixedContent()
    await this.init()
    ShowMore()
    this.$nextTick(() => {
      const digitalBookButton = new DigitalBookButton('.js-digital-book')
    })

    if (this.cajg1080ViewModel.periodicalsHtmlInfo) {
      const buttonShowmore = document.querySelector('[data-more-btn]')
      buttonShowmore.classList.add('hide')
      const listPosts = document.querySelectorAll('[data-more-content] li')
      if (listPosts.length > 3) {
        buttonShowmore.classList.remove('hide')
      } else {
        buttonShowmore.classList.add('hide')
      }
    }
  }

  /**
   * 初期処理
   */
  private async init() {
    const [caja1080ResponseModel] = await Promise.all([
      this.cajg1080Service.callAPICAJA1080(),
      // システムアクティビティログを実行する（トランスポート）
      TransportService.callAPITransport(CommonConstants.URL_CAJG1080, null, null)
    ])
    if (CommonUtil.isNotEmpty(caja1080ResponseModel.periodicalsHtmlInfo)) {
      this.cajg1080ViewModel.periodicalsHtmlInfo.content =
        CommonUtil.replacePathCMS(
          caja1080ResponseModel.periodicalsHtmlInfo.content,
          CommonConstants.TEMPLATE_CMS_PATH,
          caja1080ResponseModel.periodicalsHtmlInfo.path
        )
    } else {
      this.cajg1080ViewModel.periodicalsHtmlInfo = null
    }
  }

  /**
   * 外部サイトに遷移する。
   */
  private gotoColumnWarashibeTileSlab() {
    window.open(
      OtherUrlConstants.WARASHIBE_FINANCIAL_HEALTH_WEB_MAGAZINE,
      '_blank'
    )
  }

  /**
   * 学習メニュートップ（ログイン後）(CAJG1060 )画面に遷移する。
   */
  private gotoCAJG1060() {
    this.$router.push({ name: 'cajg1060' })
  }
}
